
import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import { ServerService } from '../../service/server/server.service';
import { ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, QuickToolbarService, RichTextEditor } from '@syncfusion/ej2-angular-richtexteditor';

@Component({
  selector: 'app-tip-detaile',
  templateUrl: './tip-detaile.component.html',
  styleUrls: ['./tip-detaile.component.scss'],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, QuickToolbarService]
})
export class TipDetaileComponent implements OnInit, OnDestroy {
  public tools: object = {
    items: ['Undo', 'Redo', '|',
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
      'SubScript', 'SuperScript', '|',
      'LowerCase', 'UpperCase', '|',
      'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
      'Indent', 'Outdent', '|', 'CreateLink',
      'Image', 'CreateTable', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen']
  };

  insertImageSettings: Object = {
    saveUrl: 'https://server1.hooshmandsazeh.com/uploadImageEditor',
    removeUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Remove',
    path: this.serverService.get_site() + "/" + this.serverService.get_path_upload_image(),
    allowedTypes: ['.png', '.jpg', '.gif', '.mp4'],
    maxWidth: '100%'
  };

  public quickTools: object = {
    image: [
      'Replace', 'Align', 'Caption', 'Remove', 'InsertLink', '-', 'Display', 'AltText', 'Dimension']
  };
  public iframe: object = { enable: true };
  public height: number = 500;


  public isOnline: any;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any;
  lang: any;
  type_task: number | undefined;
  form1_group: FormGroup | any;
  user_info: any;
  user_id: number | any;
  id: number | undefined;
  i: number | undefined;
  code: number | undefined;
  title: string | undefined;
  cate: number;
  search_array: any = [];
  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private dialog: MatDialog
    , private matDialogRef: MatDialogRef<TipDetaileComponent>) {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.create_form1();
      this.id = dialog_data.id;
      this.title = dialog_data.title;
      this.code = dialog_data.code;
      this.cate = dialog_data.cate;
      this.i = dialog_data.i;
      if (this.type_task == 1) {
        this.get_status();
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.form1_group.patchValue({
          title: dialog_data.search_array.title,
          titleen: dialog_data.search_array.titleen,
          titlear: dialog_data.search_array.titlear,
          titleru: dialog_data.search_array.titleru,
          code: dialog_data.search_array.code,
          keywords: dialog_data.search_array.keywords,

          status_id: dialog_data.search_array.status_id,
          status_title: dialog_data.search_array.status_title,

          status_id_en: dialog_data.search_array.status_id_en,
          status_title_en: dialog_data.search_array.status_title_en,

          status_id_ar: dialog_data.search_array.status_id_ar,
          status_title_ar: dialog_data.search_array.status_title_ar,

          status_id_ru: dialog_data.search_array.status_id_ru,
          status_title_ru: dialog_data.search_array.status_title_ru,

          cate: dialog_data.search_array.cate,
          cate_title: dialog_data.search_array.cate_title,
        })
      }
    }
  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }

  onselected(e: any) {
    e.filesData[0].name = "UploadFiles_" + Date.now() + "." + e.filesData[0].type;
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null),
      'titleen': new FormControl(null),
      'titlear': new FormControl(null),
      'titleru': new FormControl(null),
      'keywords': new FormControl(null),
      'code': new FormControl(null),
      'sort': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title': new FormControl(null),
      'status_id': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title_en': new FormControl(null),
      'status_id_en': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title_ar': new FormControl(null),
      'status_id_ar': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'status_title_ru': new FormControl(null),
      'status_id_ru': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'cate_title': new FormControl(null),
      'cate': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'comment': new FormControl(null),
      'comment_en': new FormControl(null),
      'comment_ar': new FormControl(null),
      'comment_ru': new FormControl(null),

    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['title'].setValidators([Validators.required])
      this.form1_group.controls['status_id'].setValidators([Validators.required])
    }

  }

  check_access(type_task: any, excel: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.title = res['result'][0].title;
            this.loading = false;
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.update(); }
            if (type_task == 3) { this.search(excel); }
            if (type_task == 4) { this.get_data(); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      titleen: this.form1_group.value.titleen,
      titlear: this.form1_group.value.titlear,
      titleru: this.form1_group.value.titleru,
      code: this.form1_group.value.code,
      keywords: this.form1_group.value.keywords,

      status_id: this.form1_group.value.status_id,
      status_title: this.form1_group.value.status_title,

      status_id_en: this.form1_group.value.status_id_en,
      status_title_en: this.form1_group.value.status_title_en,

      status_id_ar: this.form1_group.value.status_id_ar,
      status_title_ar: this.form1_group.value.status_title_ar,

      status_id_ru: this.form1_group.value.status_id_ru,
      status_title_ru: this.form1_group.value.status_title_ru,

      cate: this.form1_group.value.cate,
      cate_title: this.form1_group.value.cate_title,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10632, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'title': res['result'][0].tip_tip_site_title,
            'titleen': res['result'][0].tip_tip_site_titleen,
            'titlear': res['result'][0].tip_tip_site_titlear,
            'titleru': res['result'][0].tip_tip_site_titleru,
            'keywords': res['result'][0].tip_tip_site_keywords,
            'code': res['result'][0].tip_tip_site_code,
            'sort': res['result'][0].tip_tip_site_sort,
            'status_id': res['result'][0].status_id,
            'status_title': res['result'][0].status_title,
            'status_id_en': res['result'][0].status_id_en,
            'status_title_en': res['result'][0].status_title_en,
            'status_id_ar': res['result'][0].status_id_ar,
            'status_title_ar': res['result'][0].status_title_ar,
            'status_id_ru': res['result'][0].status_id_ru,
            'status_title_ru': res['result'][0].status_title_ru,
            'cate': res['result'][0].tip_tip_site_cate_id,
            'cate_title': res['result'][0].tip_tip_site_cate_title,
            'comment': res['result'][0].tip_tip_site_comment,
            'comment_en': res['result'][0].tip_tip_site_comment_en,
            'comment_ar': res['result'][0].tip_tip_site_comment_ar,
            'comment_ru': res['result'][0].tip_tip_site_comment_ru,
          }
          )
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 10628, "user_id": this.user_id
      , 'status_id': this.form1_group.value.status_id
      , 'status_id_en': this.form1_group.value.status_id_en
      , 'status_id_ar': this.form1_group.value.status_id_ar
      , 'status_id_ru': this.form1_group.value.status_id_ru
      , 'title': this.form1_group.value.title
      , 'titleen': this.form1_group.value.titleen
      , 'titlear': this.form1_group.value.titlear
      , 'titleru': this.form1_group.value.titleru
      , 'keywords': this.form1_group.value.keywords
      , 'sort': this.form1_group.value.sort
      , 'cate': this.form1_group.value.cate
      , 'code': this.form1_group.value.code
      , 'comment': this.form1_group.value.comment
      , 'comment_en': this.form1_group.value.comment_en
      , 'comment_ar': this.form1_group.value.comment_ar
      , 'comment_ru': this.form1_group.value.comment_ru
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0] }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
          this.serverService.send_cate('cate2');
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  update() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 10629, "user_id": this.user_id
      , 'title': this.form1_group.value.title
      , 'titleen': this.form1_group.value.titleen
      , 'titlear': this.form1_group.value.titlear
      , 'titleru': this.form1_group.value.titleru
      , 'sort': this.form1_group.value.sort
      , 'status_id': this.form1_group.value.status_id
      , 'status_id_en': this.form1_group.value.status_id_en
      , 'status_id_ar': this.form1_group.value.status_id_ar
      , 'status_id_ru': this.form1_group.value.status_id_ru
      , 'cate': this.form1_group.value.cate
      , 'code': this.form1_group.value.code
      , 'keywords': this.form1_group.value.keywords
      , 'id': this.id
      , 'comment': this.form1_group.value.comment
      , 'comment_en': this.form1_group.value.comment_en
      , 'comment_ar': this.form1_group.value.comment_ar
      , 'comment_ru': this.form1_group.value.comment_ru
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.matDialogRef.close(
            { result: res['result'][0], i: this.i }
          )
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
          this.serverService.send_cate('cate2');
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update

  get_status() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1064 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            status_id: res['result'][0].status_id,
            status_title: res['result'][0].status_title,
            status_id_en: res['result'][0].status_id,
            status_title_en: res['result'][0].status_title,
            status_id_ar: res['result'][0].status_id,
            status_title_ar: res['result'][0].status_title,
            status_id_ru: res['result'][0].status_id,
            status_title_ru: res['result'][0].status_title,
          })
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  load_services(id: number, type) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 226) {
            this.form1_group.patchValue({
              'cate': res.id,
              'cate_title': res.title
            })
          }
          if (id == 221 && type == 1) {
            this.form1_group.patchValue({
              'status_id': res.id,
              'status_title': res.title
            })
          }
          if (id == 221 && type == 2) {
            this.form1_group.patchValue({
              'status_id_en': res.id,
              'status_title_en': res.title
            })
          }
          if (id == 221 && type == 3) {
            this.form1_group.patchValue({
              'status_id_ar': res.id,
              'status_title_ar': res.title
            })
          }
          if (id == 221 && type == 4) {
            this.form1_group.patchValue({
              'status_id_ru': res.id,
              'status_title_ru': res.title
            })
          }
        }
      }
    )
  }


  reset_input(id: number, type: any) {
    if (id == 226) {
      this.form1_group.patchValue({
        'cate_title': null,
        'cate': null
      })
    }
    if (id == 221 && type == 1) {
      this.form1_group.patchValue({
        'status_id': null,
        'status_title': null
      })
    }
    if (id == 221 && type == 2) {
      this.form1_group.patchValue({
        'status_id_en': null,
        'status_title_en': null
      })
    }
    if (id == 221 && type == 3) {
      this.form1_group.patchValue({
        'status_id_ar': null,
        'status_title_ar': null
      })
    }
    if (id == 221 && type == 4) {
      this.form1_group.patchValue({
        'status_id_ru': null,
        'status_title_ru': null
      })
    }

  }


  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
